import {
  useEffect,
  useState,
} from "react";

export default function useMatrixMessages(
  client,
  roomId
) {
  const [room, setRoom] =
    useState(null);

  const [messages, setMessages] =
    useState([]);

  useEffect(() => {
    if (!client || !roomId) {
      setRoom(null);
      setMessages([]);
      return;
    }

    const currentRoom =
      client.getRoom(roomId);

    if (!currentRoom) {
      setRoom(null);
      setMessages([]);
      return;
    }

    setRoom(currentRoom);

    function loadMessages() {
      const events =
        currentRoom
          .getLiveTimeline()
          .getEvents()
          .filter(
            (event) =>
              event.getType() ===
              "m.room.message"
          );

      setMessages(events);
    }

    loadMessages();

    function handleTimeline(
      event,
      eventRoom,
      toStartOfTimeline
    ) {
      if (
        toStartOfTimeline ||
        !eventRoom ||
        eventRoom.roomId !== roomId
      ) {
        return;
      }

      if (
        event.getType() !==
        "m.room.message"
      ) {
        return;
      }

      setMessages((previous) => {
        const eventId =
          event.getId?.();

        if (
          eventId &&
          previous.some(
            (item) =>
              item.getId?.() ===
              eventId
          )
        ) {
          return previous;
        }

        return [
          ...previous,
          event,
        ];
      });
    }

    client.on(
      "Room.timeline",
      handleTimeline
    );

    return () => {
      client.removeListener(
        "Room.timeline",
        handleTimeline
      );
    };
  }, [client, roomId]);

  return {
    room,
    messages,
  };
}